<template>
  <div class="flex height100_hidden">
    <div class='left height100 left_ctn flexV'>
      <Logo></Logo>
      <div class="line line0 clearfix">
        <div class="txt0 inline_block">{{summary.product_name}}</div>
        <div class="txt1 inline_block">{{ summary.location_name && summary.location_name.join(' · ')}}</div>
        <a @click="$router.go(-1)" class="back_btn pull_right">返回</a>
      </div>
      <div class="line1 flex">
        <div class="flex1 line1_col flex">
          <div class="txt0 flex1" :class='summary.buy | getFontSizeFromNum'>{{summary.buy}}</div>
          <div class="txt1 flex1">买家
            <div class="green" v-if='summary.buy_rate < 0'>
              <span class="arrow_down"></span>
              {{summary.buy_rate}}%
            </div>
            <div class="red" v-else-if='summary.buy_rate > 0'>
              <span class="arrow_up" ></span>
              {{summary.buy_rate}}%
            </div>
            <div class="white" v-else>
              <span class="arrow_keep"></span>
              {{summary.buy_rate}}%
            </div>
          </div>
        </div>
        <div class="flex1 line1_col flex">
          <div class="txt0 flex1" :class='summary.sell | getFontSizeFromNum'>{{summary.sell}}</div>
          <div class="txt1 flex1">卖家
            <div class="green" v-if='summary.sell_rate < 0'>
              <span class="arrow_down"></span>
              {{summary.sell_rate}}%
            </div>
            <div class="red" v-else-if='summary.sell_rate > 0'>
              <span class="arrow_up" ></span>
              {{summary.sell_rate}}%
            </div>
            <div class="white" v-else>
              <span class="arrow_keep"></span>
              {{summary.sell_rate}}%
            </div>
          </div>
        </div>
      </div>
      <div class="line2 flex" >
        <div @click='tagClick("buyer")' class="pointer flex1 tag tag0" :class='{active: currentTag == "buyer"}'>采购商分布</div>
        <div @click='tagClick("seller")' class="pointer flex1 tag tag1" :class='{active: currentTag == "seller"}'>产地竞争力</div>
      </div>
      <div class="list_ctn flex1">
        <div class="list_srcoll">
          <div> <!--非无用标签，解决未知原因出现滚动条时原素错位问题-->
            <div class="list_header clearfix">
              <div class="pull_left col">排名</div>
              <div class="pull_left text_center col">所在城市</div>
              <div class="pull_left text_right col">买家热度</div>
            </div>
            <div class="list_item clearfix" v-for='(item, index) in items' :key='index'>
              <div class="pull_left col col_rank">
                <div class="rank_txt">{{item.rank}}</div>
                <span class="arrow_down" v-if='item.rank_change < 0'></span>
                <span class="arrow_up" v-else-if='item.rank_change > 0'></span>
                <span class="arrow_keep" v-else></span>
              </div>
              <div class="pull_left text_center col">{{item.location.join('')}}</div>
              <div class="pull_left text_right col col_last">{{item.buy}}
                <div class="green change_txt inline_block" v-if='item.buy_rate < 0'>
                  <span class="arrow_down"></span>
                  <span class="rate_txt inline_block">{{item.buy_rate}}%</span>
                </div>
                <div class="red change_txt inline_block" v-else-if='item.buy_rate > 0'>
                  <span class="arrow_up" ></span>
                  <span class="rate_txt inline_block">{{item.buy_rate}}%</span>
                </div>
                <div class="white change_txt inline_block" v-else>
                  <span class="arrow_keep"></span>
                  <span class="rate_txt inline_block">{{item.buy_rate}}%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Right class='flex1' :list='items' :summary='summary'></Right>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import copy from '@/utils/copy'
import Right from '@/components/Right.vue'

export default {
  created () {
    this.$store.dispatch('countyDetail/getData', {
      countyId: this.$route.params.id,
      productId: this.$route.query.product_id,
      date: this.$route.query.date,
      type: this.$route.query.type
    })
    // this.getData()
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      summary: state => state.countyDetail.summary,
      currentTag: state => state.countyDetail.currentTag,
      items: state => state.countyDetail.items
    })
  },
  methods: {
    tagClick (type) {
      if (type === this.currentTag) return
      this.$store.commit('countyDetail/setCurrentTag', type)
      const query = copy(this.$route.query)
      query.type = type
      this.$router.push({
        name: this.$route.name,
        params: this.$route.params,
        query: query
      })
    }
  },
  components: {
    Right
  }
}
</script>
